<template>
  <!-- ホルター心電図解析受付 -->
  <div id="HolterAnalysisRequestAccept">
    <div id="container">
      <psgNavi v-bind:pageid='"HolterAnalysisRequestAccept"'></psgNavi>
      <div class="labelTitle lable">ホルター心電図解析 受付</div>
      <!--検索条件 -->
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>受付番号</th>
            <td><input type="text" v-model="searchConditions.receiptNumber" maxlength="20"/></td>
            <th>種別</th>
            <td><select v-model="searchConditions.kind">
              <option></option>
              <option value="301">ホルター心電図配送ｻｰﾋﾞｽ</option>
              <!-- しばらく使わない為非表示7/6 <option value="401">ホルター心電図解析ｻｰﾋﾞｽ</option> -->
              </select></td>
            <th>デモ</th>
            <td><select v-model="searchConditions.demo">
              <option></option>
              <option value="false">含まない</option>
              <option value="true">デモのみ</option>
              </select></td>
            <th>解析方法</th>
            <td><select v-model="searchConditions.analysisMethod">
              <option v-for="method in analysisMethodList" :value="method.value" :key="method.value">{{ method.label1 }}</option>
            </select></td>
          </tr>
          <tr>
            <th>解析オプション</th>
            <td><select v-model="searchConditions.analysisOption" name="解析オプション" >
              <option v-for="method in analysisOptionList" :value="method.value" :key="method.value">{{ method.label1 }}</option>
              </select>
            </td>
            <th>依頼元</th>
            <td><input type="text" v-model="searchConditions.client" maxlength="256"/></td>            
            <th>医療機関</th>
            <td><input type="text" v-model="searchConditions.hospital" maxlength="256"/></td>
            <th>患者名</th>
            <td><input type="text" v-model="searchConditions.patientName" maxlength="100"/></td>
          </tr>
          <tr>
            <th>申込日</th>
            <td colspan="3"><input type="date" v-model="searchConditions.applicationDateStart"/> ～ <input type="date" v-model="searchConditions.applicationDateEnd"/></td>
            <th>返却希望日</th>
            <td colspan="3"><input type="date" v-model="searchConditions.returnDateStart"/> ～ <input type="date" v-model="searchConditions.returnDateEnd"/></td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch" >検索</b-button>
        </div>
      </div>
      <!-- 検索結果 -->
      <div class="result-area" v-if="hasResult" >
        <span class="result-count">件数：{{data.length}}件</span>
        <b-table
          id="psgRequestAcceptTable"
          :data="data"
          :paginated="isPaginated"
          per-page="100"
          pagination-position="both"
          default-sort="applicationDate"
          default-sort-direction="asc"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
        >
          <template slot-scope="props">
            <b-table-column field="receiptNumber" label="受付番号" width="130" sortable centered>
              <router-link :to="{name:'HolterAnalysisRequestAcceptDetail', query:{receiptNumber:encodeURIComponent(props.row.receiptNumber)}, params:{searchConditions:searchConditions}}"><a>{{props.row.receiptNumber}}</a></router-link>
            </b-table-column>
            <b-table-column field="applicationDate" label="申込日" width="130" sortable centered>
              {{props.row.applicationDate }}
            </b-table-column>
            <b-table-column field="returnDate" label="返却希望日" width="110" sortable centered >
              {{props.row.returnDate }}<span v-if="props.row.urgent" class="urgent" />
            </b-table-column>
            <b-table-column field="inspectionKind" label="種別" width="110" sortable>
              {{props.row.inspectionKind}}<span v-if="props.row.demo" class="demo" /><span v-if="props.row.depositMachineFlag" class="depo"/>
            </b-table-column>
            <b-table-column v-if="props.row.inspectionKind == 'ホルター心電図配送ｻｰﾋﾞｽ'" field="analysisMethod" label="解析方法" width="150" sortable >
              ホルター心電図
            </b-table-column>
            <b-table-column v-if="props.row.inspectionKind == 'ホルター心電図解析ｻｰﾋﾞｽ'" field="analysisMethod" label="解析方法" width="150" sortable >
              {{props.row.analysisMethod | methodFilter(analysisMethodList)}}
            </b-table-column>
            <b-table-column field="analysisOption" label="解析オプション" width="150" sortable >
              {{props.row.analysisOption | methodFilter(analysisOptionList)}}
            </b-table-column>
            <b-table-column field="client" label="依頼元" width="200" sortable >
              {{props.row.client}}
            </b-table-column>
            <b-table-column field="hospital" label="医療機関" width="200" sortable >
              {{props.row.hospital}}
            </b-table-column>
            <b-table-column field="patientName" label="患者名" width="150" sortable >
              {{props.row.patientName}}
            </b-table-column>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/philips/holterAnalysis/HolterAnalysisNaviBar";
import {choicesType} from "@/components/mock/base/const.js";
export default {
  name: "HolterAnalysisRequestAccept",
  methods: {
    doTest: function() {
      var excuteApi = this.getTestPOST;
      var successCallBack = this.getTestPOSTSuccess;
      var errorCallBack = this.getTestPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    doSearch: function() {
      var isSearchParam = false
      var keys = Object.keys(this.searchConditions)
      for(var i=0; i < keys.length; i++){
        if(this.searchConditions[keys[i]]){
          isSearchParam = true
          break;
        }
      }
      if(!isSearchParam){
        // 検索条件が１つも設定されていない場合
        this.showErrorMessage("検索条件が入力されていません。")
        return;
      }
      this.data = []
      this.hasResult = false;
      var excuteApi = this.getHAnalysisRequestListPOST;
      var successCallBack = this.getHAnalysisRequestListPOSTSuccess;
      var errorCallBack = this.getHAnalysisRequestListPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getHAnalysisRequestListPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.searchConditions));
      return client.apis.internalHolterAnalysis.getHAnalysisRequestListPOST({
        body:obj
      });
    },
    getHAnalysisRequestListPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      this.hasResult = true;
    },
    getHAnalysisRequestListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getTestPOST: function(client) {
      return client.apis.apiCommon.testCallPost({
        body:{}
      });
    },
    getTestPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      this.hasResult = true;
    },
    getTestPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getChoicesList: async function() {
      this.analysisMethodList = this.getChoiceList(this.choicesType.holterMethod, false);
      this.analysisOptionList = this.getChoiceList(this.choicesType.holterAnalysisOp, false);
      this.analysisMethodList.unshift({})
      this.analysisOptionList.unshift({})
    },
  },
  data() {
    var takeOverSearchParams = this.$route.params["searchConditions"];
    return {
      searchConditions:{
        receiptNumber:"",
        kind:"",
        demo:"",
        analysisMethod:"",
        analysisOptionList:"",
        client:"",
        hospital:"",
        patientName:"",
        applicationDateStart:"",
        applicationDateEnd:"",
        returnDateStart:"",
        returnDateEnd:""
      },
      choicesType:choicesType,
      data: [],
      isPaginated: true,
      analysisMethodList:[],
      analysisOptionList:[],
      takeOverSearchParams,
      hasResult: false
    };
  },
  async mounted() {
    // 機種マスタ取得
    await this.getChoicesList();
    if(this.takeOverSearchParams){
      this.searchConditions = this.takeOverSearchParams
      this.doSearch()
    }
  },
  filters: {
    methodFilter(value, methodList){
      var target = methodList.find(val => val.value == value)
      if(target){
        return target.label1
      }
      return ""
    },
  },
  components: {
    psgNavi: naviBar
  }
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
input {
  width: 200px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/holterAnalysis/HolterAnalysisRequestAccept.vue